module.exports = __webpack_public_path__ + "static/media/silhouette5.66e5e031.jpeg";